import Actions from '../../odata/actions';

const actions = new Actions('xeroAccount', 'xeroAccounts');

export default actions;
